import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";

var createHistory = function createHistory() {
  var listeners = [];
  return {
    listen: function listen(listener) {
      listeners.push(listener);
      window.addEventListener('popstate', function () {
        listener();
      });
    },
    navigate: function navigate(to) {
      window.history.pushState({}, null, to);

      _forEachInstanceProperty(listeners).call(listeners, function (listener) {
        return listener();
      });
    }
  };
};

var gHistory = createHistory();
var navigate = gHistory.navigate;
export { gHistory, navigate };